<script>
  import { Carousel3d, Slide } from "vue-carousel-3d";
  import Likes from "./likes/Likes.vue";
  import { mapGetters } from "vuex";
  import UserTag from "../molecules/UserTag.vue";
  import { isContestExcluded } from "../../utils/contentTypeExcluded";

  export default {
    props: ["best", "awards", "subtitle", "modal", "statusRange", "canShowDetails"],
    components: {
      Carousel3d,
      Slide,
      Likes,
      UserTag,
      UsersListVisor: () => import("../widgets/Modals/UsersListVisor.vue"),
    },
    data() {
      return {
        slides: [],
        showModalViewers: false,
        showModalLikes: false,
        participantViewers: [],
        participantLikes: [],
        timeoutId: null,
        flippedIndex: null,
        contentVisibleByIndex: {},
        flipTimeouts: {},
        hoveredIndex: null,
      };
    },
    watch: {
      best(newValue) {
        this.slides = newValue;
      },
    },
    computed: {
      ...mapGetters("competitions", ["getCompetition"]),
      slidesCarousel() {
        return this.slides;
      },
      spaceCards() {
        if (this.$screen.width > 1180) {
          return this.spaceToDesk();
        } else {
          return this.spaceToTable();
        }
      },
      isLessThan1024() {
        return this.$store.state.screen.width < 1024;
      },
      userIsAdmin() {
        return this.$userData.role === "superadmin";
      },
      currentIndex() {
        return this.$refs.mycarousel.currentIndex;
      },
      isContestTypeExcluded() {
        return isContestExcluded(this.getCompetition.typeContest);
      },
      isTipperContest() {
        return this.getCompetition.typeContest === "tipper";
      },
    },
    methods: {
      toggleFlip(state, index) {
        this.$set(this.contentVisibleByIndex, index, false);
        if (this.flipTimeouts[index]) {
          clearTimeout(this.flipTimeouts[index]);
          this.flipTimeouts[index] = null;
        }

        this.flippedIndex = state ? index : null;

        this.flipTimeouts[index] = setTimeout(() => {
          this.$nextTick(() => {
            this.$set(this.contentVisibleByIndex, index, true);
          });
          this.flipTimeouts[index] = null;
        }, 400);
      },
      showdetails(item, idx) {
        if (!this.canShowDetails) {
          return;
        }
        if (this.currentIndex === idx) {
          this.emitOpenModal(item, idx);
          return;
        }
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
          this.emitOpenModal(item, idx);
        }, 400);
      },
      emitOpenModal(item, idx) {
        this.$emit("showModalDetails", item, this.getPosition(idx), true);
      },
      getIcon(position) {
        if (position === 0) {
          return "https://new-web-site-bucket.s3.amazonaws.com/myspace/concursos/1mer.png";
        } else if (position === 2) {
          return "https://new-web-site-bucket.s3.amazonaws.com/myspace/concursos/3er.png";
        } else if (position === 1) {
          return "https://new-web-site-bucket.s3.amazonaws.com/myspace/concursos/2do.png";
        }
      },
      getPosition(position) {
        return position;
      },
      awarPosition(position) {
        const awards = this.awards || [];

        if (!awards.length) {
          return;
        }
        if (this?.statusRange) {
          position++;
          const result = awards.find((element) => position >= element.positionStart && position <= element.positionEnd);
          return result.logo;
        } else {
          if (awards && position >= 0 && position < awards.length) {
            return awards[position]?.logo;
          }
        }
      },
      pictureImage(user) {
        return this.isContestTypeExcluded ? user?.internalPicture : user?.externalPicture;
      },
      cityOfficeUser(user) {
        const { city } = user;
        return `${city}`;
      },
      nameUser(item) {
        const { artisticName, user } = item;
        return artisticName || user;
      },
      spaceToDesk() {
        const initBreakPoint = 1490;
        const valueToLess = initBreakPoint - this.$screen.width;
        const refValue = 550;
        const newValue = refValue - valueToLess / 1.4;
        return valueToLess < 1 ? refValue : newValue;
      },
      spaceToTable() {
        const initBreakPoint = 1180;
        const valueToLess = initBreakPoint - this.$screen.width;
        const refValue = 540;

        const newValue = refValue - valueToLess / 1.2;
        return valueToLess < 1 ? refValue : newValue;
      },
      showModal(users) {
        this.showModalViewers = !this.showModalViewers;
        if (!this.showModalViewers) {
          this.participantViewers = [];
        } else {
          this.participantViewers = users;
        }
      },
      showLikesMd(event, item) {
        event.stopPropagation();

        this.showModalLikes = !this.showModalLikes;
        this.participantLikes = item?.likes.length && this.showModalLikes ? item.likes.map((it) => it.userId) : [];
      },
      getParticipantViewers({ viewers = [] }) {
        return viewers.map(({ user, views }) => ({ ...user, views }));
      },
      onMouseHandler(index, state) {
        if (!this.isTipperContest) return;
        if (state && this.hoveredIndex === index) return;
        this.hoveredIndex = state ? index : null;
        this.toggleFlip(state, index);
      },
      onMouseLeave(event, index) {
        const wrapper = this.$refs["slide_" + index]?.$el;
        const related = event.relatedTarget;

        if (wrapper && related && wrapper.contains(related)) {
          return;
        }

        this.onMouseHandler(index, false);
      },
    },
    async mounted() {
      this.slides = this.best;
      this.$refs.mycarousel.goSlide(1);
      this.slides.forEach((_, i) => {
        this.$set(this.contentVisibleByIndex, i, true);
      });
    },
  };
</script>

<template>
  <div class="competitionCarousel">
    <carousel-3d
      ref="mycarousel"
      :key="slides.length"
      :autoplay="true"
      :autoplay-timeout="4000"
      :loop="true"
      :autoplayHoverPause="true"
      :height="375"
      :width="500"
      :space="spaceCards"
      :perspective="10">
      <slide
        v-for="(item, i) in slidesCarousel"
        :index="i"
        :key="i"
        :ref="'slide_' + i"
        :class="`competitionCarousel__slide ${flippedIndex === i ? 'competitionCarousel__slide--flip' : ''}`"
        @click.native="showdetails(item, i)"
        @mouseenter.native="() => onMouseHandler(i, true)"
        @mouseleave.native="(event) => onMouseLeave(event, i)">
        <div class="competitionCarousel__flipWrapper" :class="{ flipped: flippedIndex === i }">
          <div class="competitionCarousel__flipCard">
            <div class="competitionCarousel__flipCardFace competitionCarousel__flipCardFront">
              <img :src="pictureImage(item)" alt="front image" class="competitionCarousel__slideImage" />
            </div>
            <div class="competitionCarousel__flipCardFace competitionCarousel__flipCardBack">
              <img :src="item.tipImage" alt="back image" class="competitionCarousel__slideImage" />
            </div>
          </div>
        </div>
        <transition name="fade-content">
          <div v-show="contentVisibleByIndex[i]" class="competitionCarousel__descriptionContainer">
            <img v-show="awarPosition(i)" :src="awarPosition(i)" :alt="awarPosition(i)" class="competitionCarousel__carouselAwardIcon" />
            <div class="competitionCarousel__descriptionSubContainer">
              <img :src="getIcon(i)" :alt="getIcon(i)" class="competitionCarousel__carouselPositionIcon" />
              <div :class="`competitionCarousel__monitorsContainer ${flippedIndex === i ? 'competitionCarousel__monitorsContainer--flipped' : ''}`">
                <UserTag
                  v-if="!isLessThan1024"
                  class="competitionCarousel__monitorCard"
                  v-for="user in item.monitors"
                  :key="user._id"
                  :user="user"
                  :showOnlyAvatar="true"
                  :canShowTooltip="true"
                  tooltipVariant="leftPosition"
                  modifier="card" />
              </div>
              <div class="competitionCarousel__carouselAwardInformation" v-if="canShowDetails">
                <div class="competitionCarousel__nameContainer">
                  <p class="competitionCarousel__carouselAwardName">{{ nameUser(item.user) }}</p>
                  <span class="competitionCarousel__corouselAwarCountry" v-if="isTipperContest"> - {{ cityOfficeUser(item.user) }}</span>
                </div>
                <div class="competitionCarousel__contentDetails">
                  <div class="competitionCarousel__tipsContainer">
                    <img src="https://new-web-site-bucket.s3.amazonaws.com/myspace/concursos/Vector%20%283%29.svg" alt="tips icon" class="competitionCarousel__tipsIcon" v-if="isTipperContest" />
                    <span class="competitionCarousel__tips" v-if="isTipperContest">{{ item.tips }} USD</span>
                    <span class="competitionCarousel__corouselAwarCountry" v-else>{{ cityOfficeUser(item.user) }}</span>
                    <UserTag v-if="isLessThan1024" class="competitionCarousel__monitorCard" v-for="user in item.monitors" :key="user._id" :user="user" :showOnlyAvatar="true" modifier="card" />
                  </div>
                  <div class="competitionCarousel__views" @click.stop="showModal(getParticipantViewers(item))" v-if="getParticipantViewers(item).length && userIsAdmin && modal">
                    <iconic class="competitionCarousel__eye" name="eye_contets" />
                    <p class="competitionCarousel__cantViews">{{ getParticipantViewers(item).length }}</p>
                  </div>
                </div>
              </div>
              <div v-show="modal && canShowDetails" :class="`competitionCarousel__carouselModal ${item.totalLikes > 0 ? 'competitionCarousel__carouselModal--count' : ''}`">
                <div class="competitionCarousel__footerContainer">
                  <iconic name="commentContest" />
                  <span class="competitionCarousel__cantComments">{{ item.comments.length }}</span>
                </div>
                <likes
                  class="competitionCarousel__likeCard"
                  :likes="item.likes"
                  :totalLikes="item.totalLikes"
                  :postId="item._id"
                  nameEvent="likeParticipants"
                  :modalaction="(event) => showLikesMd(event, item)" />
              </div>
            </div>
          </div>
        </transition>
      </slide>
    </carousel-3d>
    <UsersListVisor :users="participantLikes" :detail="'Usuarios que han dado like a la participante:'" :closeModal="(event) => showLikesMd(event)" v-if="showModalLikes" />
    <UsersListVisor :users="participantViewers" :detail="'Usuarios que han visto la participante:'" :closeModal="showModal" v-if="showModalViewers" />
  </div>
</template>

<style lang="scss">
  .competitionCarousel {
    width: 100%;
    text-align: left;
    align-items: left;
    position: relative;
    &__contentDetails {
      @include Flex(row);
      gap: 10px;
    }
    &__monitorsContainer {
      @include Flex(column, center, center);
      position: absolute;
      bottom: 17%;
      right: 13px;
      width: 10%;
      gap: $space-6;
      z-index: 1;
      &--flipped {
        bottom: 20%;
        transform: scale(1.2);
        gap: 5px;
      }
    }
    &__monitorCard {
      .userTag__avatar {
        width: 26px;
        height: 26px;
      }
    }
    &__views {
      @include Flex(row);
      color: $white;
      gap: 10px;
      padding: 0 6px;
      font-size: 12px;
      font-weight: 600;
      border-radius: 15px;
      background-color: rgba(0, 0, 0, 0.4);
      cursor: pointer;
    }
    &__eye {
      font-size: 14px;
    }
    &__subtitleCompetition {
      font-family: $primary_font;
      font-style: italic;
      text-transform: uppercase;
      font-weight: 600;
    }
    &__slide {
      background-color: transparent;
      border-radius: 11px;
      border: none;
      cursor: pointer;
      box-shadow: 0 1px 4px rgba(99, 99, 99, 0.6);
      &--flip {
        box-shadow: none;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 28%;
        width: 100%;
        border-radius: 0 0 10px 10px;
        background-image: linear-gradient(0deg, #161616 22%, rgba(15, 15, 15, 0) 81%, rgba(19, 19, 19, 0.0452556));
      }
    }
    &__slideFigure {
      position: relative;
      margin: 0;
    }
    &__nameContainer,
    &__tipsContainer {
      @include Flex(row);
      gap: 5px;
    }
    &__tipsIcon {
      width: 15px !important;
      height: 15px;
      object-fit: cover;
    }
    &__tips {
      font-family: $sec_font;
      color: #e0be2c;
      font-size: 20px;
    }
    &__descriptionContainer {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    &__descriptionSubContainer {
      position: relative;
      width: 100%;
      height: 100%;
    }
    &__carouselAwardInformation {
      position: absolute;
      @include Flex(column, flex-start, flex-start);
      bottom: 0.8rem;
      left: 1rem;
    }
    &__carouselModal {
      position: absolute;
      @include Flex(column-reverse);
      gap: 10px;
      bottom: 0.8rem;
      right: 13px;
      &--count {
        right: 21px;
      }
    }
    &__likeCard {
      .like__button {
        @include Flex(column);
      }
      .heart-bg {
        height: 28px;
      }
      .likes__total {
        font-family: $newFont_bold;
        font-size: 12px;
        text-shadow: 0px 1px 1.5px #000000ad;
      }
    }
    &__searchIcon {
      padding: 0.5rem;
      margin-left: 10px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
      transition: all 0.4s ease;
      font-weight: bold;
      font-size: 22px;
      &:hover {
        background-color: rgba(189, 9, 9, 0.7);
        transform: scale(1.2);
      }
    }
    &__carouselPositionIcon {
      position: absolute;
      top: 1rem;
      left: 1rem;
      max-width: 53px;
      max-height: 53px;
      border-radius: 50%;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.82);
    }
    &__carouselAwardName {
      font-family: $sec_font;
      color: #fff;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.35);
      font-weight: 400;
      line-height: 1.4rem;
      font-size: 22px;
    }
    &__footerContainer {
      @include Flex(column);
      gap: $space-4;
      color: #fff;
      font-size: 18px;
    }
    &__cantComments {
      font-family: $newFont_bold;
      font-size: 12px;
      text-shadow: 0px 1px 1.5px #000000ad;
    }
    &__carouselAwardIcon {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 50px;
      max-width: 50px;
      height: 50px;
    }
    &__cantViews {
      font-family: $newFont_regular;
    }
    &__corouselAwarCountry {
      font-family: $newFont_regular;
      color: #fff;
      padding-bottom: 3px;
      font-size: 14px;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.35);
    }
    &__flipWrapper {
      perspective: 1000px;
      width: 100%;
      height: 100%;
      position: relative;
      &.flipped .competitionCarousel__flipCard {
        transform: rotateY(180deg);
      }
    }
    &__flipCard {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 0.3s ease;
    }
    &__flipCardFace {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      top: 0;
      left: 0;
      border-radius: 10px;
    }
    &__flipCardFront {
      z-index: 2;
    }
    &__flipCardBack {
      transform: rotateY(180deg);
    }
    &__slideImage {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
    @media (min-width: 768px) {
      &__carouselModal,
      &__footerContainer {
        @include Flex(row);
      }
      &__likeCard {
        .like__button {
          @include Flex(row);
        }
        .likes__total {
          font-size: 14px;
        }
      }
      &__cantComments {
        font-size: 14px;
      }
    }

    .fade-content-enter-active,
    .fade-content-leave-active {
      transition: opacity 0.4s ease;
    }
    .fade-content-enter-from,
    .fade-content-leave-to {
      opacity: 0;
    }
    .fade-content-enter-to,
    .fade-content-leave-from {
      opacity: 1;
    }
  }
</style>
